import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isWeb = () => Capacitor.getPlatform() === 'web';
// Stripe checkout has been removed — Apple IAP is the only payment path.
export const canShowStripeCheckout = () => false;
export const canShowAppleIAP = () => isIOS();
export const getPlatform = () => Capacitor.getPlatform();

// Portal builds (itch.io / CrazyGames / Poki embeds) are guest-only: no
// accounts, no IAP, no ad prompts. Baked in at build time via REACT_APP_PORTAL
// (see scripts/build-portal.sh) so a portal zip can never leak auth/paywall UI.
export const getPortal = () => process.env.REACT_APP_PORTAL || null;
export const isPortal = () => !!getPortal();

// Telemetry platform label: 'portal-<name>' | 'ios' | 'web'
export const getTelemetryPlatform = () => (isPortal() ? `portal-${getPortal()}` : getPlatform());
